import { render, staticRenderFns } from "./select-produto.vue?vue&type=template&id=b923e2d4"
import script from "./select-produto.vue?vue&type=script&lang=ts"
export * from "./select-produto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports